import styled from '@emotion/styled'


export const FlexDisplay = styled.div`
display: flex;
flex-direction: row;
`